import { Icon } from "./Icon";

export function Loading({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="feedback feedback-loading">
      <span className="spinner" /> {label}
    </div>
  );
}

export function ErrorBanner({ message }: { message: string }) {
  return (
    <div className="feedback feedback-error" role="alert">
      <Icon name="alert" size={18} /> {message}
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return (
    <div className="feedback feedback-empty">
      <Icon name="inbox" size={30} />
      <span>{message}</span>
    </div>
  );
}

export function InfoBanner({ message }: { message: string }) {
  return (
    <div className="feedback feedback-info">
      <Icon name="check" size={18} /> {message}
    </div>
  );
}
